
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/lift-tickets",
      function () {
        return require("private-next-pages/[region]/[resort]/lift-tickets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/lift-tickets"])
      });
    }
  